/*
 * types.js
 * trt_cms2
 *
 * Created by Hisyam on 27/2/2020.
 * Copyright (c) 2020 Terato Tech. All rights reserved.
 */

export const GET_ERRORS = 'GET_ERRORS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const CREATE_MESSAGE = 'CREATE_MESSAGE';

// Auth
export const USER_LOADING = 'USER_LOADING';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';

export const SHOW_ERROR = 'SHOW_ERROR';

// POSTS
export const FETCH_POSTS = 'FETCH_POSTS';
export const FETCH_POSTS_FULFILLED = 'FETCH_POSTS_FULFILLED';
export const FETCH_POSTS_REJECTED = 'FETCH_POSTS_REJECTED';
export const FETCH_POST = 'FETCH_POST';
export const FETCH_POST_FULFILLED = 'FETCH_POST_FULFILLED';
export const FETCH_POST_REJECTED = 'FETCH_POST_REJECTED';
export const NEW_POST = 'NEW_POSTS';
export const NEW_POST_FULFILLED = 'NEW_POSTS_FULFILLED';
export const NEW_POST_REJECTED = 'NEW_POSTS_REJECTED';
export const ADD_POST = 'ADD_POSTS';
export const ADD_POST_FULFILLED = 'ADD_POSTS_FULFILLED';
export const ADD_POST_REJECTED = 'ADD_POSTS_REJECTED';
export const UPDATE_POST = 'UPDATE_POSTS';
export const UPDATE_POST_FULFILLED = 'UPDATE_POSTS_FULFILLED';
export const UPDATE_POST_REJECTED = 'UPDATE_POSTS_REJECTED';
export const DELETE_POST = 'DELETE_POST';
export const DELETE_POST_FULFILLED = 'DELETE_POST_FULFILLED';
export const DELETE_POST_REJECTED = 'DELETE_POST_REJECTED';
export const RESET_REDIRECT_POST = 'RESET_REDIRECT_POST';

// POST CATEGORY AND TAG
export const ADD_POST_CATEGORY_FROM_SELECT = 'ADD_POST_CATEGORY_FROM_SELECT';
export const ADD_POST_CATEGORY_FROM_SELECT_FULFILLED = 'ADD_POST_CATEGORY_FROM_SELECT_FULFILLED';
export const ADD_POST_TAG_FROM_SELECT = 'ADD_POST_TAG_FROM_SELECT';
export const ADD_POST_TAG_FROM_SELECT_FULFILLED = 'ADD_POST_TAG_FROM_SELECT_FULFILLED';

// CAREERS
export const FETCH_CAREERS = 'FETCH_CAREERS';
export const FETCH_CAREERS_FULFILLED = 'FETCH_CAREERS_FULFILLED';
export const FETCH_CAREER = 'FETCH_CAREER';
export const FETCH_CAREER_FULFILLED = 'FETCH_CAREER_FULFILLED';
export const NEW_CAREER = 'NEW_CAREER';
export const NEW_CAREER_FULFILLED = 'NEW_CAREER_FULFILLED';
export const ADD_CAREER = 'ADD_CAREER';
export const ADD_CAREER_FULFILLED = 'ADD_CAREER_FULFILLED';
export const UPDATE_CAREER = 'UPDATE_CAREER';
export const UPDATE_CAREER_FULFILLED = 'UPDATE_CAREER_FULFILLED';
export const DELETE_CAREER = 'DELETE_CAREER';
export const DELETE_CAREER_FULFILLED = 'DELETE_CAREER_FULFILLED';
export const RESET_REDIRECT_CAREER = 'RESET_REDIRECT_CAREER';

// CLIENTS
export const FETCH_CLIENTS = 'FETCH_CLIENTS';
export const FETCH_CLIENTS_FULFILLED = 'FETCH_CLIENTS_FULFILLED';
export const FETCH_CLIENTS_REJECTED = 'FETCH_CLIENTS_REJECTED';
export const FETCH_CLIENT = 'FETCH_CLIENT';
export const FETCH_CLIENT_FULFILLED = 'FETCH_CLIENT_FULFILLED';
export const FETCH_CLIENT_REJECTED = 'FETCH_CLIENT_REJECTED';
export const ADD_CLIENT = 'ADD_CLIENT';
export const ADD_CLIENT_FULFILLED = 'ADD_CLIENT_FULFILLED';
export const ADD_CLIENT_REJECTED = 'ADD_CLIENT_REJECTED';
export const UPDATE_CLIENT = 'UPDATE_CLIENT';
export const UPDATE_CLIENT_FULFILLED = 'UPDATE_CLIENT_FULFILLED';
export const UPDATE_CLIENT_REJECTED = 'UPDATE_CLIENT_REJECTED';
export const DELETE_CLIENT = 'DELETE_CLIENT';
export const DELETE_CLIENT_FULFILLED = 'DELETE_CLIENT_FULFILLED';
export const DELETE_CLIENT_REJECTED = 'DELETE_CLIENT_REJECTED';
export const RESET_REDIRECT_CLIENT = 'RESET_REDIRECT_CLIENT';

// IMAGES
export const FETCH_IMAGES = 'FETCH_IMAGES';
export const FETCH_IMAGES_FULFILLED = 'FETCH_IMAGES_FULFILLED';
export const FETCH_IMAGE = 'FETCH_IMAGE';
export const FETCH_IMAGE_FULFILLED = 'FETCH_IMAGE_FULFILLED';
export const NEW_IMAGE = 'NEW_IMAGE';
export const NEW_IMAGE_FULFILLED = 'NEW_IMAGE_FULFILLED';
export const ADD_IMAGE = 'ADD_IMAGE';
export const ADD_IMAGE_FULFILLED = 'ADD_IMAGE_FULFILLED';
export const UPDATE_IMAGE = 'UPDATE_IMAGE';
export const UPDATE_IMAGE_FULFILLED = 'UPDATE_IMAGE_FULFILLED';
export const DELETE_IMAGE = 'DELETE_IMAGE';
export const DELETE_IMAGE_FULFILLED = 'DELETE_IMAGE_FULFILLED';
export const RESET_REDIRECT_IMAGE = 'RESET_REDIRECT_IMAGE';
export const SEARCH_IMAGES = 'SEARCH_IMAGES';
export const SEARCH_IMAGES_FULFILLED = 'SEARCH_IMAGES_FULFILLED';

// PAGES
export const FETCH_PAGES = 'FETCH_PAGES';
export const FETCH_PAGES_FULFILLED = 'FETCH_PAGES_FULFILLED';
export const FETCH_PAGE = 'FETCH_PAGE';
export const FETCH_PAGE_FULFILLED = 'FETCH_PAGE_FULFILLED';
export const NEW_PAGE = 'NEW_PAGE';
export const NEW_PAGE_FULFILLED = 'NEW_PAGE_FULFILLED';
export const ADD_PAGE = 'ADD_PAGE';
export const ADD_PAGE_FULFILLED = 'ADD_PAGE_FULFILLED';
export const UPDATE_PAGE = 'UPDATE_PAGE';
export const UPDATE_PAGE_FULFILLED = 'UPDATE_PAGE_FULFILLED';
export const DELETE_PAGE = 'DELETE_PAGE';
export const DELETE_PAGE_FULFILLED = 'DELETE_PAGE_FULFILLED';
export const RESET_REDIRECT_PAGE = 'RESET_REDIRECT_PAGE';

// TESTIMONIALS
export const FETCH_TESTIMONIALS = 'FETCH_TESTIMONIALS';
export const FETCH_TESTIMONIALS_FULFILLED = 'FETCH_TESTIMONIALS_FULFILLED';
export const FETCH_TESTIMONIAL = 'FETCH_TESTIMONIAL';
export const FETCH_TESTIMONIAL_FULFILLED = 'FETCH_TESTIMONIAL_FULFILLED';
export const ADD_TESTIMONIAL = 'ADD_TESTIMONIAL';
export const ADD_TESTIMONIAL_FULFILLED = 'ADD_TESTIMONIAL_FULFILLED';
export const UPDATE_TESTIMONIAL = 'UPDATE_TESTIMONIAL';
export const UPDATE_TESTIMONIAL_FULFILLED = 'UPDATE_TESTIMONIAL_FULFILLED';
export const DELETE_TESTIMONIAL = 'DELETE_TESTIMONIAL';
export const DELETE_TESTIMONIAL_FULFILLED = 'DELETE_TESTIMONIAL_FULFILLED';
export const RESET_REDIRECT_TESTIMONIAL = 'RESET_REDIRECT_TESTIMONIAL';

// WORKS
export const FETCH_WORKS = 'FETCH_WORKS';
export const FETCH_WORKS_FULFILLED = 'FETCH_WORKS_FULFILLED';
export const NEW_WORK = 'NEW_WORK';
export const NEW_WORK_FULFILLED = 'NEW_WORK_FULFILLED';
export const FETCH_WORK = 'FETCH_WORK';
export const FETCH_WORK_FULFILLED = 'FETCH_WORK_FULFILLED';
export const ADD_WORK = 'ADD_WORK';
export const ADD_WORK_FULFILLED = 'ADD_WORK_FULFILLED';
export const UPDATE_WORK = 'UPDATE_WORK';
export const UPDATE_WORK_FULFILLED = 'UPDATE_WORK_FULFILLED';
export const DELETE_WORK = 'DELETE_WORK';
export const DELETE_WORK_FULFILLED = 'DELETE_WORK_FULFILLED';
export const RESET_REDIRECT_WORK = 'RESET_REDIRECT_WORK';

// SERVICES
export const FETCH_SERVICES = 'FETCH_SERVICES';
export const FETCH_SERVICES_FULFILLED = 'FETCH_SERVICES_FULFILLED';
export const FETCH_SERVICE = 'FETCH_SERVICE';
export const FETCH_SERVICE_FULFILLED = 'FETCH_SERVICE_FULFILLED';
export const NEW_SERVICE = 'NEW_SERVICE';
export const NEW_SERVICE_FULFILLED = 'NEW_SERVICE_FULFILLED';
export const ADD_SERVICE = 'ADD_SERVICE';
export const ADD_SERVICE_FULFILLED = 'ADD_SERVICE_FULFILLED';
export const UPDATE_SERVICE = 'UPDATE_SERVICE';
export const UPDATE_SERVICE_FULFILLED = 'UPDATE_SERVICE_FULFILLED';
export const DELETE_SERVICE = 'DELETE_SERVICE';
export const DELETE_SERVICE_FULFILLED = 'DELETE_SERVICE_FULFILLED';
export const RESET_REDIRECT_SERVICE = 'RESET_REDIRECT_SERVICE';

// MAESTROS
export const FETCH_MAESTROS = 'FETCH_MAESTROS';
export const FETCH_MAESTROS_FULFILLED = 'FETCH_MAESTROS_FULFILLED';
export const FETCH_MAESTRO = 'FETCH_MAESTRO';
export const FETCH_MAESTRO_FULFILLED = 'FETCH_MAESTRO_FULFILLED';
export const NEW_MAESTRO = 'NEW_MAESTRO';
export const NEW_MAESTRO_FULFILLED = 'NEW_MAESTRO_FULFILLED';
export const ADD_MAESTRO = 'ADD_MAESTRO';
export const ADD_MAESTRO_FULFILLED = 'ADD_MAESTRO_FULFILLED';
export const UPDATE_MAESTRO = 'UPDATE_MAESTRO';
export const UPDATE_MAESTRO_FULFILLED = 'UPDATE_MAESTRO_FULFILLED';
export const DELETE_MAESTRO = 'DELETE_MAESTRO';
export const DELETE_MAESTRO_FULFILLED = 'DELETE_MAESTRO_FULFILLED';
export const RESET_REDIRECT_MAESTRO = 'RESET_REDIRECT_MAESTRO';

// EMPLOYEES
export const FETCH_EMPLOYEES = 'FETCH_EMPLOYEES';
export const FETCH_EMPLOYEES_FULFILLED = 'FETCH_EMPLOYEES_FULFILLED';
export const FETCH_EMPLOYEE = 'FETCH_EMPLOYEE';
export const FETCH_EMPLOYEE_FULFILLED = 'FETCH_EMPLOYEE_FULFILLED';
export const NEW_EMPLOYEE = 'NEW_EMPLOYEE';
export const NEW_EMPLOYEE_FULFILLED = 'NEW_EMPLOYEE_FULFILLED';
export const ADD_EMPLOYEE = 'ADD_EMPLOYEE';
export const ADD_EMPLOYEE_FULFILLED = 'ADD_EMPLOYEE_FULFILLED';
export const UPDATE_EMPLOYEE = 'UPDATE_EMPLOYEE';
export const UPDATE_EMPLOYEE_FULFILLED = 'UPDATE_EMPLOYEE_FULFILLED';
export const DELETE_EMPLOYEE = 'DELETE_EMPLOYEE';
export const DELETE_EMPLOYEE_FULFILLED = 'DELETE_EMPLOYEE_FULFILLED';
export const RESET_REDIRECT_EMPLOYEE = 'RESET_REDIRECT_EMPLOYEE';

// ACHIEVEMENTS
export const FETCH_ACHIEVEMENTS = 'FETCH_ACHIEVEMENTS';
export const FETCH_ACHIEVEMENTS_FULFILLED = 'FETCH_ACHIEVEMENTS_FULFILLED';
export const FETCH_ACHIEVEMENT = 'FETCH_ACHIEVEMENT';
export const FETCH_ACHIEVEMENT_FULFILLED = 'FETCH_ACHIEVEMENT_FULFILLED';
export const NEW_ACHIEVEMENT = 'NEW_ACHIEVEMENT';
export const NEW_ACHIEVEMENT_FULFILLED = 'NEW_ACHIEVEMENT_FULFILLED';
export const ADD_ACHIEVEMENT = 'ADD_ACHIEVEMENT';
export const ADD_ACHIEVEMENT_FULFILLED = 'ADD_ACHIEVEMENT_FULFILLED';
export const UPDATE_ACHIEVEMENT = 'UPDATE_ACHIEVEMENT';
export const UPDATE_ACHIEVEMENT_FULFILLED = 'UPDATE_ACHIEVEMENT_FULFILLED';
export const DELETE_ACHIEVEMENT = 'DELETE_ACHIEVEMENT';
export const DELETE_ACHIEVEMENT_FULFILLED = 'DELETE_ACHIEVEMENT_FULFILLED';
export const RESET_REDIRECT_ACHIEVEMENT = 'RESET_REDIRECT_ACHIEVEMENT';

// EMPLOYEES
export const FETCH_SECTIONS = 'FETCH_SECTIONS';
export const FETCH_SECTIONS_FULFILLED = 'FETCH_SECTIONS_FULFILLED';
export const FETCH_SECTION = 'FETCH_SECTION';
export const FETCH_SECTION_FULFILLED = 'FETCH_SECTION_FULFILLED';
export const NEW_SECTION = 'NEW_SECTION';
export const NEW_SECTION_FULFILLED = 'NEW_SECTION_FULFILLED';
export const ADD_SECTION = 'ADD_SECTION';
export const ADD_SECTION_FULFILLED = 'ADD_SECTION_FULFILLED';
export const UPDATE_SECTION = 'UPDATE_SECTION';
export const UPDATE_SECTION_FULFILLED = 'UPDATE_SECTION_FULFILLED';
export const DELETE_SECTION = 'DELETE_SECTION';
export const DELETE_SECTION_FULFILLED = 'DELETE_SECTION_FULFILLED';
export const RESET_REDIRECT_SECTION = 'RESET_REDIRECT_SECTION';


function createTypes(label) {
  const types = {
    FETCH_ALL: `FETCH_${label}S`,
    FETCH_ALL_FULFILLED: `FETCH_${label}S_FULFILLED`,
    FETCH_ONE: `FETCH_${label}`,
    FETCH_ONE_FULFILLED: `FETCH_${label}_FULFILLED`,
  };
  types[`FETCH_${label}S`] = `FETCH_${label}S`;
  types[`FETCH_${label}_FULFILLED`] = `FETCH_${label}_FULFILLED`;
  types[`FETCH_${label}`] = `FETCH_${label}`;
  types[`FETCH_${label}_FULFILLED`] = `FETCH_${label}_FULFILLED`;
  types[`NEW_${label}`] = `NEW_${label}`;
  types[`NEW_${label}_FULFILLED`] = `NEW_${label}_FULFILLED`;
  types[`ADD_${label}`] = `ADD_${label}`;
  types[`ADD_${label}_FULFILLED`] = `ADD_${label}_FULFILLED`;
  types[`UPDATE_${label}`] = `UPDATE_${label}`;
  types[`UPDATE_${label}_FULFILLED`] = `UPDATE_${label}_FULFILLED`;
  types[`DELETE_${label}`] = `DELETE_${label}`;
  types[`DELETE_${label}_FULFILLED`] = `DELETE_${label}_FULFILLED`;
  types[`RESET_REDIRECT_${label}`] = `RESET_REDIRECT_${label}`;
  return types;
}